import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Size, Color } from '../../const'

export const TextInputGroup = ({ label, direction, items }) => (
  <Wrapper>
    {label && <Label>{label}</Label>}
    <InputGroup direction={direction}>
      {items.map((item) => (
        <InputStyle
          key={item.key}
          width={item.width}
          height={item.height}
          margin={item.margin}
          type={item.type}
          name={item.name}
          value={item.value}
          maxLength={item.maxLength}
          onChange={item.onChange}
          onBlur={item.onBlur}
          placeholder={item.placeholder}
          aria-label={item.ariaLabel}
        />
      ))}
    </InputGroup>
    <ErrorGroup>
      {items.map((item) => (
        <Error key={item.key} width={item.width} margin={item.margin}>
          {item.errorMessage}
        </Error>
      ))}
    </ErrorGroup>
  </Wrapper>
)

const Wrapper = styled.div`
  width: 100%;
  padding: 8px 0;
`

const InputGroup = styled.div`
  display: flex;
  width: 100%;
  flex-direction: ${(props) => props.direction};
`

const ErrorGroup = styled.div`
  display: flex;
  width: 100%;
  flex-direction: ${(props) => props.direction};
`

const Label = styled.label`
  width: 30%;
  padding-right: 30px;
  text-align: right;
  vertical-align: top;
  font-size: ${Size.FONT.LABEL};
`

const InputStyle = styled.input`
  padding: 12px 16px;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  vertical-align: top;
  text-align: left;
  margin: ${(props) => props.margin};
  color: #b3b3b3;
  background-color: #fff;
  font-size: 16px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.63;
  letter-spacing: 0.21px;
  border: solid 1px ${Color.LINE.NORMAL};
  border-radius: 2px;
  :: placeholder {
    color: #b3b3b3;
  }
`

const Error = styled.div`
  color: ${Color.FONT.DANGER};
  width: ${(props) => props.width};
  margin: ${(props) => props.margin};
`

TextInputGroup.propTypes = {
  label: PropTypes.string,
  items: PropTypes.array,
}
